import gql from "graphql-tag";

export default gql`
  mutation validateCertificate($params: CertificateInput) {
    validateCertificate(params: $params) {
      rfc
      valid
      serial
      endDate
      type
      rfcMatch
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/VerifyCertificate.js